export default __webpack_public_path__ + "static/media/counting_machine_1.ef69f6a3.mp3";